export enum SfWorkflowActionType {
	FieldUpdate = 'fieldUpdate',
	EmailAlert = 'workflowAlert'
}
